// extracted by mini-css-extract-plugin
export default {"address":"addBranch_address__tBjD5","button":"addBranch_button__86RFz","formTab_root":"addBranch_formTab_root__qFCvg"};